<template>
    <div>
        <b-row v-for="(contract, index) in data" :contract="contract" :key="index" class="mb-2">
            <b-colxx lg="12">
                <span class="log-indicator align-middle mr-4" :class="index === 0 ? 'border-info' : 'border-warning'"/>
                <span class="align-middle font-weight-medium mt-1">
                    Contract Signed | From: {{ contract.data.attributes.from }}, To: {{ contract.data.attributes.to }}
                </span>

                <a class="ml-3 text-info" style="cursor: pointer" @click="$emit('view', contract.contract_id)">
                    <span>View</span>
                </a>
                <span class="mx-1">|</span>
                <a class="text-warning" style="cursor: pointer" @click="$emit('edit', contract.contract_id)">
                    <span>Edit</span>
                </a>
                <span class="mx-1">|</span>
                <a class="text-danger" style="cursor: pointer" @click="$emit('delete', contract)">
                    <span>Delete</span>
                </a>
            </b-colxx>
        </b-row>
    </div>
</template>

<script>
export default {
    props: ['data'],
}
</script>
